if($('.our-gardens-block').length) {

    $('.our-gardens-block').each(function () {

        let navItems = $(this).find('.garden-group-nav-item'),
            gardenGroups = $(this).find('.garden-group');

        navItems.on('click', function () {

            console.log('here');

            if($(this).hasClass('active')) return true;

            let group = $(this).data('group'),
                newGardenGroup = $('#group-item-' + group);

            navItems.removeClass('active');
            $(this).addClass('active');

            gardenGroups.removeClass('showing');

            setTimeout(function () {
                gardenGroups.addClass('d-none');
                newGardenGroup.removeClass('d-none');
            }, 310);

            setTimeout(function () {
                newGardenGroup.addClass('showing');
            }, 320);

        });

    });

}
